import { useEffect, useState } from 'react';
import BasicLayout from 'layout/BasicLayout';

import { Link, useLocation, useNavigate } from 'react-router-dom';

import Switch from '@mui/material/Switch';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';

import ArgonBox from 'component/Argon/ArgonBox';
import ArgonTypography from 'component/Argon/ArgonTypography';
import ArgonInput from 'component/Argon/ArgonInput';
import ArgonButton from 'component/Argon/ArgonButton';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import login, { loginSchema } from 'api/auth/login';
import axios from 'axios';

import useAuth from 'auth/hook/useAuth';
import Iconify from 'component/iconify';
import ModalAlert from './ModalAlert';

function SignInPage() {
  const { auth, setAuth, persist, setPersist } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [showPwd, setShowPwd] = useState(false);
  const [modal, setModal] = useState(true);

  const {
    setError,
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(loginSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const from = location.state?.from?.pathname || '/dashboards';

  useEffect(() => {
    if (auth?.accessToken) {
      navigate(from, { replace: true });
    }
    if (auth?.username) {
      setValue('email', auth.username);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSetRememberMe = (e) => setPersist(e.target.checked);

  const onSubmit = (data) => {
    login(data)
      .then((resData) => {
        if (process.env.NODE_ENV === 'development') {
          console.log(resData);
        }
        setAuth(resData);
        navigate(from, { replace: true });
      })
      .catch((error) => {
        if (axios.isAxiosError(error)) {
          if (error.response.status == 401) {
            setError('password', { type: 400, message: 'อีเมลหรือรหัสผ่านไม่ถูกต้อง' });
          } else {
            setError('password', {
              type: 400,
              message: `[${error.response.status}] some thing went wrong please contact addmin.`,
            });
          }
        }
        console.log(error);
      });
  };

  return (
    <BasicLayout>
      <Card>
        <CardHeader sx={{ textAlign: 'center' }} title="เข้าสู่ระบบ" subheader="ด้วยอีเมลและรหัสผ่านที่ลงทะเบียนไว้" />
        <CardContent>
          <ArgonBox component="form" role="form">
            <ArgonBox mb={2}>
              <Controller
                name="email"
                control={control}
                render={({ field }) => (
                  <ArgonInput
                    name="email"
                    type="email"
                    placeholder="อีเมล"
                    size="large"
                    error={!!errors?.email}
                    {...field}
                  />
                )}
              />
            </ArgonBox>
            <ArgonBox mb={2}>
              <Controller
                name="password"
                control={control}
                render={({ field }) => (
                  <ArgonInput
                    type={showPwd ? 'text' : 'password'}
                    placeholder="รหัสผ่าน"
                    size="large"
                    error={!!errors?.password}
                    {...field}
                    endAdornment={
                      <ArgonBox
                        sx={{ cursor: 'pointer' }}
                        onClick={() => {
                          setShowPwd((prev) => !prev);
                        }}
                      >
                        {showPwd ? (
                          <Iconify width={24} icon="eva:eye-outline" />
                        ) : (
                          <Iconify width={24} icon="eva:eye-off-outline" />
                        )}
                      </ArgonBox>
                    }
                  />
                )}
              />
              {(!!errors?.email || !!errors?.password) && (
                <ArgonTypography variant="caption" color="error">
                  อีเมลหรือรหัสผ่านไม่ถูกต้อง
                </ArgonTypography>
              )}
            </ArgonBox>
            <ArgonBox display="flex" alignItems="center">
              <Switch
                color="info"
                onChange={handleSetRememberMe}
                checked={persist}
                inputProps={{ 'aria-label': 'controlled' }}
              />
              <ArgonTypography
                variant="button"
                fontWeight="regular"
                onClick={handleSetRememberMe}
                sx={{ cursor: 'pointer', userSelect: 'none' }}
              >
                &nbsp;&nbsp;จำฉันไว้ในระบบ
              </ArgonTypography>
            </ArgonBox>
            <ArgonBox mt={4} mb={1}>
              <ArgonButton color="info" size="large" fullWidth onClick={handleSubmit(onSubmit)}>
                เข้าสู่ระบบ
              </ArgonButton>
            </ArgonBox>
            <ArgonBox mt={3} textAlign="center">
              <ArgonTypography variant="button" color="text" fontWeight="regular">
                ยังไม่เคยใช้บริการเลยโปรด{' '}
                <ArgonTypography component={Link} to="/sign-up" variant="button" color="info" fontWeight="medium">
                  สมัครสมาชิก
                </ArgonTypography>
              </ArgonTypography>
            </ArgonBox>
          </ArgonBox>
        </CardContent>
      </Card>
      <ModalAlert open={modal} handleClose={() => setModal(false)} />
    </BasicLayout>
  );
}

export default SignInPage;
